import { gql } from "@apollo/client";

const DevicesSubscription = gql`
  subscription AvailableDevices {
    listen(topic: "device_update") {
      query {
        allDevices(condition: { isActive: true }, orderBy: DEVICE_NAME_ASC) {
          nodes {
            id
            deviceName
          }
        }
      }
    }
  }
`;

const hash = "dee8720c92e19898687f7dfe0e2a68f6fb53477635c7e2d3dcaa2df5cd987d2e";

export { DevicesSubscription, hash };
